import React from "react";
import Input from "../common/Input";
import Checkbox from "../common/Checkbox";

function SoutherINKinship({ data, handleChange, handleSave }) {
  return (
    <>
      <div className="row mb-4 ms-4">
        <div className="col-4">
          <Checkbox
            name="kinshipPlacement"
            label="Kinship Placement"
            onChange={handleChange}
            checked={data.DynamicFields.results.kinshipPlacement === "true"}
          />
        </div>
      </div>
      <div className="mb-4 ms-4">
        <Input
          name="substanceUseHistory"
          label="History with Opioids/Substance Abuse"
          onChange={handleChange}
          value={data.DynamicFields.results.substanceUseHistory}
          rows="3"
        />
      </div>
      <div className="fw-bold">Family History/Needs:</div>
      <div className="row ms-4">
        <div className="col">
          <Checkbox
            name="opioids"
            label="Opioids/Substance Use"
            onChange={handleChange}
            checked={data.DynamicFields.results.opioids === "true"}
          />
        </div>
        <div className="col">
          <Checkbox
            name="suicidal"
            label="Suicidal Thoughts/Behaviors"
            onChange={handleChange}
            checked={data.DynamicFields.results.suicidal === "true"}
          />
        </div>
        <div className="col">
          <Checkbox
            name="homicidal"
            label="Homicidal Thoughts/Behaviors"
            onChange={handleChange}
            checked={data.DynamicFields.results.homicidal === "true"}
          />
        </div>
      </div>
      <div className="row ms-4">
        <div className="col">
          <Checkbox
            name="placementDistruption"
            label="Placement Disruption"
            onChange={handleChange}
            checked={data.DynamicFields.results.placementDistruption === "true"}
          />
        </div>
        <div className="col">
          <Checkbox
            name="frequentCrisis"
            label="Frequent Crisis"
            onChange={handleChange}
            checked={data.DynamicFields.results.frequentCrisis === "true"}
          />
        </div>
        <div className="col"></div>
      </div>
      <div className="ms-4">
        <Input
          name="other"
          label="Other"
          onChange={handleChange}
          value={data.DynamicFields.results.other}
          rows="3"
        />
        <Input
          name="serviceExpectations"
          label="Service Expectations"
          onChange={handleChange}
          value={data.DynamicFields.results.serviceExpectations}
          rows="3"
        />
      </div>
      <button className="btn btn-primary ms-2" onClick={() => handleSave()}>
        Save Referral
      </button>
    </>
  );
}

export default SoutherINKinship;
